export const filtros_por_tipos = {
  movimentacao: {
    id: 0,
    descricao: 'Filtros de movimentação',
    largura: '35%',
    dados: [
      {
        title: "Itens Novos (Venda menor ou igual a 90 dias)",
        chave: "item_novo",
        tooltip: `Produtos com venda menor ou igual a 90 dias.`,
      },
      {
        title: "Itens com Movimentação (Venda) maior que 90 dias",
        chave: "com_movimentacao",
        tooltip: `Produtos com venda maior que 90 dias.`,
      },
      {
        title: "Itens sem Movimentação (Venda)",
        chave: "sem_movimentacao",
        tooltip: `Produtos que não tiveram nenhuma movimentação (Venda).`,
      },
      {
        chave: "histogramas",
      }
    ]
  },
  aplicacao: {
    id: 1,
    descricao: 'Filtros de aplicação',
    largura: '23%',
    dados: [
      {
        title: "Similares",
        chave: "similar",
        tooltip: `Produtos que possuem itens similares em outro fornecedor.`,
      },
      {
        title: "Herança",
        chave: "heranca",
        tooltip: `Produtos que herdam o comportamento de movimentações de outro produto.`,
      },
      {
        title: "Influência de Previsão",
        tooltip: `Produtos com influência de projeção aplicado.`,
        callback_filtro: (produto) => {
          return parseFloat(produto.fator_atuacao) !== 1;
        }
      },
      {
        title: "Analise por lote",
        chave: "analise_lote",
        tooltip: `Produtos que possuem itens em analise por lote.`,
      },
      {
        title: "Produtos com Venda Futura",
        chave: "venda_futura",
        tooltip: `Produtos com Venda Futura.`,
      },
      {
        title: "Produtos de Baixa Movimentação",
        chave: "baixa_movimentacao",
        tooltip: `Produtos de Baixa Movimentação.`,
        callback_filtro: produto => produto.baixa_movimentacao,
      },
    ],
  },
  status_produto: {
    id: 2,
    descricao: 'Filtros de status produto',
    largura: '25%',
    dados: [
      {
        title: "Excesso",
        chave: "excesso",
        tooltip: "Saldo de estoque acima do Estoque Máximo",
      },
      {
        title: "Nível adequado",
        chave: "adequado",
        tooltip: "Saldo de estoque maior que o Ponto de Pedido e menor ou igual ao Estoque Máximo",
      },
      {
        title: "Baixa exposição a ruptura",
        chave: "baixa_exposicao_ruptura",
        tooltip: "Saldo estoque menor ou igual ao Ponto de Pedido e Cobertura de Estoque maior ou igual ao Lead time",
      },
      {
        title: "Elevada exposição a ruptura",
        chave: "elevada_exposicao_ruptura",
        tooltip: "Saldo de estoque menor ou igual ao Ponto de Pedido e Cobertura de Estoque menor que o Lead time",
      },
      {
        title: "Ruptura",
        tooltip: "Saldo de estoque igual a 0",
        callback_filtro: produto => {
          return parseFloat(produto.estoque) === 0;
        }
      },
    ],
  },
  curvas: {
    id: 3,
    descricao: 'Filtros de curvas',
    largura: '17%',
    dados: [
      {
        title: "A - Elevado",
        tooltip: 'Produtos com custo de aquisição elevado',
        callback_filtro: produto => {
          return produto.classificacao_criticidade === 'Z';
        }
      },
      {
        title: "B - Intermediário",
        tooltip: 'Produtos com custo de aquisição intermediário',
        callback_filtro: produto => {
          return produto.classificacao_criticidade === 'Y';
        }
      },
      {
        title: "C - Baixo",
        tooltip: 'Produtos com custo de aquisição baixo',
        callback_filtro: produto => {
          return produto.classificacao_criticidade === 'X';
        }
      },
      {
        title: "P - Popular",
        tooltip: 'Frequência de saída: popular',
        callback_filtro: produto => {
          return produto.classificacao_popularidade === 'P';
        }
      },
      {
        title: "Q - Média",
        tooltip: 'Frequência de saída: média',
        callback_filtro: produto => {
          return produto.classificacao_popularidade === 'Q';
        }
      },
      {
        title: "R - Baixa",
        tooltip: 'Frequência de saída: baixa',
        callback_filtro: produto => {
          return produto.classificacao_popularidade === 'R';
        }
      },
    ]
  }
};
